import { Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { SettingsService } from 'app/services/core/settings.service';
import { SearchLabsService } from 'app/services/searchLabs/searchLabs.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from 'app/services/core/shared.service';
import { ICertificateReportMatrixViewModel, ICertificateReportViewModel, IFoaReportViewModel } from 'app/models/report/reports';
import { drawDOM, exportPDF } from '@progress/kendo-drawing';
import '@progress/kendo-drawing/pdf';
import { CertificateService } from 'app/services/lab-user-menu/certificate.service';

@Component({
  selector: 'certificateReport',
  templateUrl: './certificateReport.component.html',
  styleUrls: ['./certificateReport.component.scss']
})

export class CertificateReportComponent {
  
  @ViewChild('pdf') pdf: PDFExportComponent;
  public certData: ICertificateReportViewModel = {} as ICertificateReportViewModel;
  public matrixData: ICertificateReportMatrixViewModel[] = [];
  public uniqueAnalyteNames: string[] = [];
  public certId: number = 0;
  public certList: { matrix: string, foaList: { method: string, foas: IFoaReportViewModel[] }[] }[] = [];
  private file: File = null;
  public issueDate: string = '';
  public expirationDate: string = '';

  constructor(public searchLabsService: SearchLabsService,  
    public settings: SettingsService,
    private dialogRef: MatDialogRef<CertificateReportComponent>,
    private sharedService: SharedService,
    private certificateService: CertificateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // console.log('certificate report for application', this.sharedService.currentApplication);
    this.certData = this.data.certData;
    this.issueDate = this.data.certData.issueDate;
    this.expirationDate = this.data.certData.expirationDate;
    this.certId = this.data.certId;
    this.matrixData = this.data.certData.analytes || [];
    this.certificateList(this.matrixData);
  }

  // Getter for address with proper encoding for PDF
  get displayAddress(): string {
    return this.certData?.address || '';
  }

  certificateList(cert: ICertificateReportMatrixViewModel[]): void {
    // Get unique analyte names
    const names = cert.map(analyte => analyte.name);
    this.uniqueAnalyteNames = [...new Set(names)];
    // console.log('unique analyte names', this.uniqueAnalyteNames);
  }

  getAnalytesByMatrix(analyteName: string, matrix: string): string {
    const analytes = this.matrixData.filter(a => a.name === analyteName && a.matrix === matrix);
    return analytes.length > 0 ? analyteName : '';
  }

  // Helper method to normalize special characters for PDF (replaces accented chars with ASCII equivalents)
  encodeForPdf(text: string): string {
    if (!text) return '';
    return text
      .replace(/[éèêë]/g, 'e')
      .replace(/[ÉÈÊË]/g, 'E')
      .replace(/[àâä]/g, 'a')
      .replace(/[ÀÂÄ]/g, 'A')
      .replace(/[ùûü]/g, 'u')
      .replace(/[ÙÛÜ]/g, 'U')
      .replace(/[îï]/g, 'i')
      .replace(/[ÎÏ]/g, 'I')
      .replace(/[ôö]/g, 'o')
      .replace(/[ÔÖ]/g, 'O')
      .replace(/[ç]/g, 'c')
      .replace(/[Ç]/g, 'C')
      .replace(/[ñ]/g, 'n')
      .replace(/[Ñ]/g, 'N');
  }

  ngOnInit(): void {
  }

  printReport(): void {
    if (this.pdf) {
      this.pdf.saveAs('ORELAP_Certificate_Report.pdf');
      this.savePdfToDatabase();
    }
  }

  savePdfToDatabase(): void {
    const element = document.querySelector('.report-content');
    if (!element) {
      console.error('PDF content element not found');
      return;
    }

    this.pdf.export().then((group) => {
      return exportPDF(group);
    }).then((dataUri) => {
      // Convert data URI to Blob
      const byteString = atob(dataUri.split(',')[1]);
      const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      const blob = new Blob([ab], { type: mimeString });
      const fileName: string = `ORELAP_Certificate_Report.pdf`;

      // this.downloadFile(`ORELAP_Certificate_ReportXXX.pdf`, blob);
      const formData = new FormData();
      // Save to database
      
      formData.append('file', blob, fileName);
      this.certificateService.savePrintedCertificate(
        this.certId,
        formData
      ).subscribe(
        response => {
          alert('PDF saved to database successfully');
        },
        error => {
          alert('Error saving PDF to database: ' + error.message);
        }
      );
    }).catch((error) => {
      alert('Error generating PDF ' + error.message);
    });
  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }
  
  closeDialog(): void {
    this.dialogRef.close();
  }

}
